import React, { useEffect } from 'react';
import SEO from '../utils/SEO';
import BannerBlock from '../components/complex/bannerBlock/bannerBlock';
import FeaturedConcerts from '../components/complex/featuredConcerts/featuredConcerts';
import AboutBlock from '../components/complex/aboutBlock/aboutBlock';
import OrganizersBlock from '../components/complex/organizersBlock/organizersBlock';
import LatestNews from '../components/complex/latestNews/latestNews';
import { userActions } from '../redux/actions/user.actions';
import { connect } from 'react-redux';
import { startLoader } from '../components/common/Loader';

function Home ({ getMetaData, getHomeData, getNewsListing, getConcerts, ...props }) {
  useEffect(() => {
    getMetaData('Home');
    startLoader();
    getHomeData();
    getConcerts();
    getNewsListing(1, 3);
  }, [getHomeData, getNewsListing, getConcerts]);

  const metaData = props.metaData?.res;
  const aboutText = props.homeData?.items?.res?.about;
  const organizers = props.homeData?.items?.res?.greeting_words;
  const latestNews = props.newsData?.items?.res?.data;
  const bannerData = props.homeData?.items?.res.slider;
  const concerts = props.concert_list?.items?.data?.slice(0, 3);
    console.log('concerts');
    console.log(concerts);
  return (
    <>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />

      <BannerBlock
        data={bannerData}
        color='white'
        position='center'
        pageName='homeBanner'
      />

      <FeaturedConcerts data={concerts && concerts} />
      <AboutBlock leftPadding rightPadding data={aboutText} />
      <OrganizersBlock leftPadding rightPadding organizerData={organizers} />
      <LatestNews leftPadding rightPadding news={latestNews} />
    </>
  );
}

function mapState (state) {
  return {
    metaData: state.getMeta,
    homeData: state.getHome,
    newsData: state.getNewsListing,
    concert_list: state.getConcerts,
  };
}

const actionCreators = {
  getMetaData: userActions.getMetaData,
  getHomeData: userActions.getHomeData,
  getConcerts: userActions.getConcerts,
  getNewsListing: userActions.getNewsListing,
};

Home.fetchMeta = () => actionCreators.getMetaData('Home');

export default connect(mapState, actionCreators)(Home);
